import React from 'react';
import { SearchFilled } from '@tag/tag-icons';

import DatePickerTag4 from '@/components/common/DatePicker/DatePickerTag4';
import SectionIcon from '@/components/common/SectionIcon/SectionIcon';
import styles from 
  '../../../pages/ContractDetails/RightPanel/History/history-search.module.scss';

interface Props {
  title?: string;
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  date: Date | null | undefined;
  onDateChange: (d: Date | null | undefined) => void;
  showClear?: boolean;
}

export default function HistorySearchHeader({
  title = 'History',
  searchTerm,
  onSearchChange,
  date,
  onDateChange,
  showClear,
}: Props) {
  return (
    <div className={styles.stickyHeader}>
      <div className={styles.headerContent}>
        <div className={styles.titleSection}>
          <SectionIcon />
          <span className={styles.titleText}>{title}</span>
        </div>
        <div className={styles.searchSection}>
          <div className={styles.searchInputWrapper}>
            <input
              type="text"
              placeholder="Search history..."
              value={searchTerm}
              onChange={onSearchChange}
              className={styles.searchInput}
            />
            <SearchFilled className={styles.searchIcon} />
          </div>
          <div className={styles.datePickerWrapper}>
            <div className={styles.datePickerContainer}>
              <DatePickerTag4
                value={date}
                onChange={({ value }) => onDateChange(value)}
              />
              {showClear && date && (
                <button
                  type="button"
                  onClick={() => onDateChange(null)}
                  className={styles.clearButton}
                  title="Clear date filter"
                >
                  ×
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
